var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sidebar-right" }, [
      _c("h1", { staticClass: "modal-h1 mb-3" }, [
        _c("button", {
          staticClass: "btn btn-back",
          attrs: { type: "button" },
          on: { click: _vm.closeModal }
        }),
        _vm._v("\n      Customer info\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "l-bg-white position-relative" }, [
        _c("div", { staticClass: "row border-bottom pb-2 mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6 px-1 mb-2" },
            [
              _c("div", { staticClass: "select-wrap" }, [
                _c("label", [_vm._v("Phone")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.customer.phone,
                      expression: "data.customer.phone"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    disabled: !_vm.$_can("companies.customers.update"),
                    placeholder: "Enter Phone",
                    maxlength: "14"
                  },
                  domProps: { value: _vm.data.customer.phone },
                  on: {
                    keydown: function($event) {
                      _vm.maskPhone($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data.customer, "phone", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "phone" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6 px-1 mb-2" },
            [
              _c("div", { staticClass: "select-wrap" }, [
                _c("label", [_vm._v("Email")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.customer.email,
                      expression: "data.customer.email"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    disabled: !_vm.$_can("companies.customers.update"),
                    placeholder: "Enter Email"
                  },
                  domProps: { value: _vm.data.customer.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data.customer, "email", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6 px-1 mb-2" },
            [
              _c("div", { staticClass: "select-wrap" }, [
                _c("label", [_vm._v("First name")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.customer.first_name,
                      expression: "data.customer.first_name"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    disabled: !_vm.$_can("companies.customers.update"),
                    placeholder: "Enter First Name"
                  },
                  domProps: { value: _vm.data.customer.first_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.data.customer,
                        "first_name",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "name" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6 px-1 mb-2" },
            [
              _c("div", { staticClass: "select-wrap" }, [
                _c("label", [_vm._v("Last name")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.customer.last_name,
                      expression: "data.customer.last_name"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    disabled: !_vm.$_can("companies.customers.update"),
                    placeholder: "Enter Last Name"
                  },
                  domProps: { value: _vm.data.customer.last_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.data.customer,
                        "last_name",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("error-field", {
                attrs: { errors: _vm.errors, field: "last_name" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.leadId && !_vm.data.customer.mod_link_sent
            ? _c("div", { staticClass: "col-md-12 check-field" }, [
                _c(
                  "label",
                  {
                    class: {
                      "check-open": _vm.data.customer.make_mod_customer === true
                    },
                    attrs: { for: "make-mod" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.changeModCustomer($event)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "checkmark" }),
                    _vm._v(
                      " Make this customer a Mod24 customer\n            "
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.customer.make_mod_customer,
                          expression: "data.customer.make_mod_customer"
                        }
                      ],
                      staticClass: "btn-check",
                      attrs: { type: "checkbox", id: "make-mod" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.data.customer.make_mod_customer
                        )
                          ? _vm._i(_vm.data.customer.make_mod_customer, null) >
                            -1
                          : _vm.data.customer.make_mod_customer
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.data.customer.make_mod_customer,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.data.customer,
                                  "make_mod_customer",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.data.customer,
                                  "make_mod_customer",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.data.customer,
                              "make_mod_customer",
                              $$c
                            )
                          }
                        }
                      }
                    })
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row border-bottom pb-2 mb-3" }, [
          _c("div", { staticClass: "col-md mb-3" }, [
            _c("h4", [_vm._v("Additional contacts")]),
            _vm._v(" "),
            _c(
              "form",
              {
                attrs: { autocomplete: "off" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [
                _vm._l(_vm.data.customer.contacts, function(contact, index) {
                  return _c("div", { key: index, staticClass: "row mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-5 pl-1 pr-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Additional phone")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: contact.phone,
                                expression: "contact.phone"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "tel",
                              autocomplete: "false",
                              disabled: !_vm.$_can(
                                "companies.customers.update"
                              ),
                              placeholder: "Enter Phone",
                              maxlength: "14"
                            },
                            domProps: { value: contact.phone },
                            on: {
                              keydown: function($event) {
                                _vm.maskPhone(index, $event)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(contact, "phone", $event.target.value)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "contacts." + index + ".phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5 pl-1 pr-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Additional email")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: contact.email,
                                expression: "contact.email"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "email",
                              placeholder: "Enter Email",
                              autocomplete: "false",
                              disabled: !_vm.$_can("companies.customers.update")
                            },
                            domProps: { value: contact.email },
                            on: {
                              keydown: function($event) {
                                _vm.clearError($event)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(contact, "email", $event.target.value)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "contacts." + index + ".email"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-1 pr-0 pl-5 pt-3 text-right" },
                      [
                        _vm.$_can("companies.customers.update")
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-clear p-1",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.removeContact(index)
                                  }
                                }
                              },
                              [_c("span", { staticClass: "mod-icon-clear" })]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                }),
                _vm._v(" "),
                _vm.$_can("companies.customers.update")
                  ? _c(
                      "button",
                      {
                        staticClass: "btn add-button",
                        attrs: { type: "button" },
                        on: { click: _vm.addAdditionalContact }
                      },
                      [
                        _vm._m(0),
                        _vm._v(
                          "\n              Add additional contact\n            "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row border-bottom pb-2 mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("h4", [_vm._v("Payment Info")]),
              _vm._v(" "),
              _c("payment", {
                attrs: {
                  customer: _vm.data.customer,
                  company: _vm.data.company,
                  "is-mod": _vm.isMod,
                  width: "col-12"
                },
                on: {
                  update: function($event) {
                    _vm.$emit("update")
                  }
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.$_can("companies.customers.update")
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12 pr-0 text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.closeModal }
                  },
                  [_vm._v("\n            Cancel\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ld-ext-right",
                    class: _vm.loadingButton ? "running" : "",
                    attrs: {
                      type: "button",
                      disabled: _vm.buttonDisabled || !_vm.isValid
                    },
                    on: {
                      click: function($event) {
                        _vm.editCustomer(_vm.data.customer.id)
                      }
                    }
                  },
                  [
                    _vm._v("\n            Save\n            "),
                    _c("div", { staticClass: "ld ld-ball ld-flip" })
                  ]
                )
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("span", { staticClass: "mod-icon-add" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5c0393c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c0393c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideModalCustomerInfo.vue
// module id = null
// module chunks = 